<div
  class="select-field"
  [ngClass]="{
    disabled: disabled,
    readonly: readonly,
    invalid: invalid,
    clear: clearedStyle,
    small: small
  }"
>
  <label *ngIf="label && !clearedStyle" for="{{ labelFor }}" class="select-field-label">
    <span class="select-field-label-border-left"></span>
    <span class="select-field-label-content">{{ getLabel() }}</span>
    <span class="select-field-label-border-right"></span>
  </label>

  <div #field class="select-field-wrapper">
    <div *ngIf="!autocomplete" class="select-field-chevron-box">
      <i class="fas fa-chevron-down"></i>
    </div>

    <ng-content #fieldElement select="[fieldElement]"></ng-content>

    <label for="{{ labelFor }}" class="search-icon">
      <i *ngIf="autocomplete" class="fas fa-search"></i>
    </label>
  </div>

  <ng-content #fieldMessages select="[fieldMessages]"></ng-content>
</div>
